'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _infoPopoversPageTemplate = require('./infoPopoversPageTemplate.html');

var _infoPopoversPageTemplate2 = _interopRequireDefault(_infoPopoversPageTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var infoPopoversPage = {
  bindings: {
    content: '@',
    actionOnly: '@',
    referingPage: '@',
    moreInfo: '@'
  },
  template: '<button type="button" class="button button-clear button-balanced icon icon-right ion-ios-information page--icon" ng-class="{\'action--icon\': $ctrl.actionOnly}" ng-click="$ctrl.openPopover($event)"></button>',
  controller: function controller($scope, $ionicPopover) {
    var _this = this;

    var content = this.content;

    // .fromTemplate() method
    var template = _infoPopoversPageTemplate2.default;

    this.popover = $ionicPopover.fromTemplate(template, { scope: $scope });

    this.openPopover = function ($event) {
      _this.popover.show($event);
    };

    this.closePopover = function () {
      _this.popover.hide();
    };
    //Cleanup the popover when we're done with it!
    $scope.$on('$destroy', function () {
      _this.popover.remove();
    });
    // Execute action on hide popover
    $scope.$on('popover.hidden', function () {
      // Execute action
    });
    // Execute action on remove popover
    $scope.$on('popover.removed', function () {
      // Execute action
    });
  }
};

exports.default = infoPopoversPage;


/** WEBPACK FOOTER **
 ** ./src/app/directives/popovers/infoPopoversPage.js
 **/